export default __webpack_public_path__ + "static/media/jez edit II.5aaefc85.png";